module.exports = __webpack_public_path__ + "img/bannerimg.313ec6cd.png";